module.exports = __webpack_public_path__ + "static/media/05.15e71fb4.png";